var map = {
	"./akum_100_poziom.png": "Ykwe",
	"./akum_120_poziom.png": "Myzq"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "BgPj";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/akumulator ^\.\/akum_.*_poziom\.png$
// module id = BgPj
// module chunks = 1